import {
  IMAGEM_PRODUTO_UPLOAD,
  CARGA_IMAGEM_PRODUTO
} from "../actions/imagemProduto";
import { ERRORS_SHOW } from "../actions/errors";
import Api from "../../service/api-web";

const state = {};

const getters = {};

const actions = {
  [IMAGEM_PRODUTO_UPLOAD]: ({ dispatch }, payload) => {
    return new Promise((resolve, reject) => {
      Api.v4.imagemProduto
        .uploadProductImages(payload)
        .then(resp => {
          resolve(resp.data);
        })
        .catch(err => {
          dispatch(ERRORS_SHOW, err);
          reject(err);
        });
    });
  },
  [CARGA_IMAGEM_PRODUTO]: ({ dispatch, getters }, payload) => {
    return new Promise((resolve, reject) => {
      Api.v4.imagemProduto
        .loadProductImages(getters.getFornecedorId, payload)
        .then(resp => {
          resolve(resp.data);
        })
        .catch(err => {
          dispatch(ERRORS_SHOW, err);
          reject(err);
        });
    });
  }
};

const mutations = {};

export default {
  state,
  getters,
  actions,
  mutations
};
